function hasRemoveDate(appliance) {
  return String((appliance && appliance.removeDate) || '').trim() !== '';
}

function sortAppliancesRemovedLast(appliances) {
  const rows = Array.isArray(appliances) ? appliances : [];
  const active = [];
  const removed = [];
  for (const appliance of rows) {
    if (hasRemoveDate(appliance)) removed.push(appliance);
    else active.push(appliance);
  }
  return active.concat(removed);
}

module.exports = { sortAppliancesRemovedLast };
